import { h } from "preact";

export const DEFAULT_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const EXTENSION_MIME_TYPES = {
  gif: "image/gif",
  jpg: "image/jpeg",
  png: "image/png",
  pdf: "application/pdf",
};
export function mapExtensions(exts) {
  return exts.map((ext) => EXTENSION_MIME_TYPES[ext]);
}
